import { orderBy } from 'lodash';

import { iaRa } from 'lib/helpers/utility';

export const getUniqueTags = (tags, selectedTags) => {
  const allTags = iaRa(tags);

  const filteredSelectedTags = iaRa(selectedTags)?.filter((selectedTag) =>
    allTags.some((tag) => tag?.id === selectedTag?.id)
  );

  const combinedTags = [...allTags, ...filteredSelectedTags];

  const uniqueTags = iaRa(combinedTags)?.reduce((acc, tag) => {
    if (!acc.some((existingTag) => existingTag?.id === tag?.id)) {
      acc.push(tag);
    }
    return acc;
  }, []);

  return orderBy(uniqueTags, [(tag) => tag?.name?.toLowerCase() || ''], ['asc']);
};
